export const CompanyAdminRoleEnum = {
    OWNER: 'OWNER', // User who creates the company. Can add/remove company admins and set roles. Can do everything else, no restrictions.
    FULL_ADMIN: 'FULL_ADMIN', // Can do everything, but not remove the owner.
    OFFICE_MANAGER: 'OFFICE_MANAGER', // Can see and upload new offices.
    VIEWER: 'VIEWER', // Only can see.
    BILLS_APPROVER: 'BILLS_APPROVER', // Can approve bills.
    BILLS_PAYER: 'BILLS_PAYER', // Can pay bills, but not create nor modify offices.
};
